import { Product } from "@Types/cart";
import { DraftProduct } from "@Types/draft";
import { isMobile } from "@Utils/device";

const productsNotEditable = ["gift", "printable-gift"];

export const isProductEditable = (product: Product | DraftProduct): boolean =>
  !productsNotEditable.includes(product.tag) &&
  !product.outOfStock &&
  (!isMobile() || (isMobile() && product.isKustomAvailableOnMobile));
